import { i18n } from '@/plugins/i18n'

export const priorities = {
    LOW: 0,
    MIDDLE: 1,
    HIGH: 2,
} 

export const priorityStr = {
    LOW: i18n.t('ticket.priority.low'),
    MIDDLE: i18n.t('ticket.priority.middle'),
    HIGH: i18n.t('ticket.priority.high'),
    get(priority) {
        let priority_str = null;
        Object.keys(priorities).forEach(function (item, index) {
            if(priorities[item] === priority) {
                priority_str = priorityStr[item]
            }
        })

        return priority_str
    }
}

export const priorityVariant = (priority) => {
    if(priority === priorities.HIGH) {
        return 'success'
    }

    if(priority === priorities.MIDDLE) {
        return 'info'
    }

    if(priority === priorities.LOW) {
        return 'secondary'
    }

    return 'danger'
} 